var _BLOCK_TITLES;
// import { isFeatureEnabled } from 'utils/lib/isFeatureEnabled'
// import { GROUP_OFFER_TYPE_PROP_TYPES } from './groups'

var LANDING_PAGES = {
  title: 'Pages',
  label: 'page',
  value: 'landing_page',
  plural: 'landing_pages',
  url: '/pages'
};
var SIGNUP_TYPE = 'signup';
var PAYMENT_TYPE = 'payment';
var GROUP_TYPE = 'group';
var OFFER_TYPES = function OFFER_TYPES(format) {
  var _Object$assign, _ref;
  return Object.assign((_Object$assign = {}, _Object$assign[SIGNUP_TYPE] = "signup_" + format, _Object$assign[PAYMENT_TYPE] = "payment_" + format, _Object$assign), format === LANDING_PAGES.value && (_ref = {}, _ref[GROUP_TYPE] = "group_" + format, _ref));
};
var PRODUCTS_SECTION = 'product';
var CUSTOM_TEXT_SECTION = 'custom_text';
var TEXT_SECTION = 'text';
// export const SIGNUP_METHODS_SECTION = 'signup_methods'
var LINKS_SECTION = 'link';
var HEADER_SECTION = 'header';
var CONSOLIDATED_SECTION = 'consolidated';

// block.type will = SIGNUP_SECTION
// then block.signup_block can be email, sms or consolidated
var SIGNUP_SECTION = 'signup';
var NEWSLETTERS_SIGNUP_SECTION = 'email';
var TEXT_SIGNUP_SECTION = 'sms';
var VCARD_BLOCK_SECTION = 'vcard';
"https://s3.amazonaws.com/customtext." + (process.env.STAGE === 'production' ? '' : process.env.STAGE + ".") + "pico.tools";
var OFFER_TYPE_PROP_TYPES = [SIGNUP_TYPE, PAYMENT_TYPE];
(_BLOCK_TITLES = {}, _BLOCK_TITLES[HEADER_SECTION] = 'Header', _BLOCK_TITLES[TEXT_SECTION] = 'Text', _BLOCK_TITLES[CUSTOM_TEXT_SECTION] = 'Text', _BLOCK_TITLES[NEWSLETTERS_SIGNUP_SECTION] = 'Signup', _BLOCK_TITLES[TEXT_SIGNUP_SECTION] = 'Text Signup', _BLOCK_TITLES[PRODUCTS_SECTION] = 'Products', _BLOCK_TITLES[LINKS_SECTION] = 'Link', _BLOCK_TITLES[TEXT_SIGNUP_SECTION] = 'Text Signup', _BLOCK_TITLES[CONSOLIDATED_SECTION] = 'Signup', _BLOCK_TITLES[VCARD_BLOCK_SECTION] = 'vCard', _BLOCK_TITLES);

export { CONSOLIDATED_SECTION, CUSTOM_TEXT_SECTION, GROUP_TYPE, HEADER_SECTION, LANDING_PAGES, LINKS_SECTION, NEWSLETTERS_SIGNUP_SECTION, OFFER_TYPES, OFFER_TYPE_PROP_TYPES, PAYMENT_TYPE, PRODUCTS_SECTION, SIGNUP_SECTION, SIGNUP_TYPE, TEXT_SECTION, TEXT_SIGNUP_SECTION, VCARD_BLOCK_SECTION };
//# sourceMappingURL=offers.js.map
